import { jsx as _jsx } from "react/jsx-runtime";
import { ThemeSpaceVariable } from '@caspeco/casper-ui-library.base-ui.theme';
import { Checkbox as ChakraCheckbox } from '@chakra-ui/react';
import React from 'react';
import { CheckboxIcon } from './checkbox-icon';
/**
 * Used in forms when a user needs to select multiple values from several options.
 *
 * @see Docs https://bit.cloud/caspeco/casper-ui-library/components/checkbox
 * @see WAI-ARIA https://www.w3.org/WAI/ARIA/apg/patterns/checkbox/
 */
export const Checkbox = React.forwardRef(({ children, size = 'md', variant = 'normal', display = 'flex', alignItems = 'center', justifyContent = 'flex-start', gap = ThemeSpaceVariable.Small, isChecked, isIndeterminate, ...props }, ref) => {
    return (_jsx(ChakraCheckbox, { size: size, variant: variant, colorScheme: "none", display: display, alignItems: alignItems, isChecked: isChecked, gap: gap, justifyContent: justifyContent, isIndeterminate: isIndeterminate, "data-indeterminate": isIndeterminate, icon: _jsx(CheckboxIcon, { variant: variant, size: size, isChecked: isChecked, isIndeterminate: isIndeterminate }), ref: ref, ...props, children: children }));
});
//# sourceMappingURL=checkbox.js.map